import React from 'react'
import PropTypes from 'prop-types'

import { Button } from '../common'

const SidebarPopup = React.forwardRef(({ email, onLogout, msg }, ref) => (
  <article
    ref={ref}
    className="popup-l popup popup-right"
    style={{
      left: 50,
      top: 30
    }}
  >
    <section className="popup_content">
      <div className="list">
        <div className="list_item">
          <div className="list_item_sec-primary">
            <h4 className="no-mrg text-color-theme">{email}</h4>
          </div>
        </div>
        <div className="list_item list_item-clickable" onClick={onLogout}>
          <Button
            iconPosition="left"
            id="logout-btn"
            title={msg('common.sidebar.logoutUser', { email })}
            xIcon="logout"
            xStyle="flat"
          >
            {msg('common.sidebar.logout')}
          </Button>
        </div>
      </div>
    </section>
  </article>
))

SidebarPopup.propTypes = {
  email: PropTypes.string,
  onLogout: PropTypes.func,
  msg: PropTypes.func
}

export { SidebarPopup }
